import { useQuery, useQueryClient } from '@tanstack/react-query';
import { ResourceQueryService } from '@lib/common-sdk';
import { ProjectBranchInfrastructureServiceViewModel } from '@lib/api-interface';

export const useProjectBranchInfrastructureServiceView = (projectBranchInfrastructureServiceId: string | undefined) => {
  const queryKey = ['projectBranchInfrastructureServiceViews', projectBranchInfrastructureServiceId];
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKey,
    queryFn: (context) => {
      return ResourceQueryService.findOneByField<ProjectBranchInfrastructureServiceViewModel>(
        '/api/resource/projectBranchInfrastructureServiceViews',
        'projectBranchInfrastructureServiceId',
        projectBranchInfrastructureServiceId,
      );
    },
    staleTime: 3000,
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey });
  };

  return [query, invalidateQuery] as const;
};
